/**
 * Loads static section HTML into terms modals when dialog-component fires dialog:open.
 * Expects: dialog-component[data-terms-section-path] and [data-terms-section-content] inside the dialog.
 */

const SECTION_ID_DEFAULT = 'page-terms-embed';

/**
 * @param {string} pagePath
 * @param {string} sectionId
 */
function sectionRenderUrl(pagePath, sectionId) {
  const sep = pagePath.includes('?') ? '&' : '?';
  return `${pagePath}${sep}section_id=${encodeURIComponent(sectionId)}`;
}

/**
 * @param {ParentNode} root
 */
export function bindTermsSectionModals(root = document) {
  root.querySelectorAll('dialog-component[data-terms-section-path]').forEach((component) => {
    if (component.dataset.termsLoaderBound) return;
    component.dataset.termsLoaderBound = '1';

    const pagePath = component.dataset.termsSectionPath?.trim();
    const sectionId = component.dataset.termsSectionId?.trim() || SECTION_ID_DEFAULT;
    const container = component.querySelector('[data-terms-section-content]');
    const errorText = component.dataset.termsLoadError?.trim() || '';

    if (!pagePath || !container) return;

    component.addEventListener('dialog:open', () => {
      if (container.dataset.loaded === 'true') return;

      const url = sectionRenderUrl(pagePath, sectionId);
      container.setAttribute('data-terms-loading', '');

      fetch(url, { headers: { Accept: 'text/html' } })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then((html) => {
          container.innerHTML = html;
          container.dataset.loaded = 'true';
          container.removeAttribute('data-terms-loading');
        })
        .catch(() => {
          container.removeAttribute('data-terms-loading');
          container.dataset.loaded = 'error';
          if (errorText) container.textContent = errorText;
        });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bindTermsSectionModals());
} else {
  bindTermsSectionModals();
}

document.addEventListener('shopify:section:load', () => bindTermsSectionModals());
